<template>
  <v-card class="pa-4 elevation-0 rounded-xl h-100-pct hover-shadow chart-membergrowth">
    <v-row>
      <v-col cols="12" class="pb-0">
        <div class="font-size-12 cl-grey font-weight-500">Potensi Komisi</div>
      </v-col>
    </v-row>
    <v-row class="ml-0">
      <v-col class="pl-0" cols="12" sm="4" md="4" lg="4" v-if="false">
        <v-card class="rounded-xl brown lighten-5 elevation-0">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-icon>mdi-wallet</v-icon>
            <div class="cl-grey font-size-11 text-capitalize ml-1">Komisi Titik</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="">
            <div class="pl-1 font-size-14 cl-primary font-weight-bold">{{ potency.bonus_node | toRupiah }}</div>
          </v-col>
        </v-card>
      </v-col>
      <v-col class="pl-0" cols="12" sm="4" md="4" lg="4">
        <v-card class="rounded-xl brown lighten-5 elevation-0">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-icon>mdi-wallet</v-icon>
            <div class="cl-grey font-size-11 text-capitalize ml-1">Komisi Sponsor</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="">
            <div class="pl-1 font-size-14 cl-primary font-weight-bold">{{ potency.bonus_sponsor | toRupiah }}</div>
          </v-col>
        </v-card>
      </v-col>
      <v-col class="pl-0" cols="12" sm="4" md="4" lg="4">
        <v-card class="rounded-xl brown lighten-5 elevation-0">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-icon>mdi-wallet</v-icon>
            <div class="cl-grey font-size-11 text-capitalize ml-1">Komisi Pasangan</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="">
            <div class="pl-1 font-size-14 cl-primary font-weight-bold">{{ potency.bonus_match | toRupiah }}</div>
          </v-col>
        </v-card>
      </v-col>
      <v-col class="pl-0" cols="12" sm="4" md="4" lg="4" v-if="false">
        <v-card class="rounded-xl brown lighten-5 elevation-0">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-icon>mdi-wallet</v-icon>
            <div class="cl-grey font-size-11  text-capitalize ml-1">Komisi RO Bulan Ini</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="">
            <div class="pl-1 font-size-14 cl-primary font-weight-bold">{{ potency.bonus_cashback | toRupiah }}</div>
          </v-col>
        </v-card>
      </v-col>
      <!-- <v-col class="pl-0">
        <v-card class="rounded-xl brown lighten-5 elevation-0">
          <v-col cols="12" sm="12" md="12" class="d-flex align-center">
            <v-icon>mdi-wallet</v-icon>
            <div class="cl-grey font-size-11 text-capitalize ml-1">Komisi Penjualan Bulan Ini</div>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="">
            <div class="pl-1 font-size-14 cl-primary font-weight-bold">{{ potency.bonus_unilevel | toRupiah }}</div>
          </v-col>
        </v-card>
      </v-col> -->
    </v-row>
  </v-card>
</template>

<script>

export default {
  data() {
    return {
		}
  },
  props: {
    potency: Object,
  }
}
</script>